import { buildUrl } from '../../helpers';
import Feature from 'Services/Feature';

export default {
    methods: {
        setSamNavMap(sellsyadminCommons, samTabs) {
            if (
                this.dataoverview.data.sellsyadmin.id &&
                this.dataoverview.data.sellsyadmin.enabled &&
                (this.dataoverview.data.sellsyadmin.maintenance == false) &&
                sellsyadminCommons
            ) {
                let tabs = sellsyadminCommons;

                if (Feature.isEnabled('sam-cart-availability-for-legacy-renew')) {
                    tabs = tabs.concat(samTabs);
                } else {
                    tabs = tabs.concat(
                        this.dataoverview.data.sellsyadmin.version == 3 ? samTabs : [],
                    );
                }
                this.navMap.find((nav) => nav.id == 'plugin').items = this.navMap
                    .find((nav) => nav.id == 'plugin')
                    .items.concat(tabs);
            }
        },
        setMoreNav(moreNav) {
            if (moreNav) {
                const samMoreNav = [];
                moreNav.map((moreNavItem) => {
                    if (
                        moreNavItem.versions.includes(
                            parseInt(this.dataoverview.data.sellsyadmin.version),
                        )
                    ) {
                        if (
                            moreNavItem.id == 'connection' &&
                            this.dataoverview.data.sellsyadmin.id == null
                        ) {
                            return;
                        } else {
                            const parameters = [
                                {
                                    key: 'linkedid',
                                    value: parseInt(this.dataoverview.data.identity.id),
                                },
                                {
                                    key: 'corpid',
                                    value: parseInt(this.dataoverview.data.sellsyadmin.id),
                                    type: 'int',
                                },
                                {
                                    key: 'canBlockUnblockAccount',
                                    value: this.dataoverview.data.sellsyadmin
                                        .canBlockUnblockAccount,
                                    type: 'bool',
                                },
                                {
                                    key: 'canDisableSalesCart',
                                    value: this.dataoverview.data.sellsyadmin.canDisableSalesCart,
                                    type: 'bool',
                                },
                                {
                                    key: 'canDisableSaasBilling',
                                    value: this.dataoverview.data.sellsyadmin.canDisableSaasBilling,
                                    type: 'bool',
                                },
                                {
                                    key: 'canDisableTrialImportLimit',
                                    value: this.dataoverview.data.sellsyadmin
                                        .canDisableTrialImportLimit,
                                    type: 'bool',
                                },
                                {
                                    key: 'canSynchronizeDataOnThird',
                                    value: this.dataoverview.data.sellsyadmin
                                        .canSynchronizeDataOnThird,
                                    type: 'bool',
                                },
                                {
                                    key: 'canEditUtm',
                                    value: this.dataoverview.data.sellsyadmin.canEditUtm,
                                    type: 'bool',
                                },
                                {
                                    key: 'canManageThirdPayer',
                                    value: this.dataoverview.data.sellsyadmin.canManageThirdPayer,
                                    type: 'bool',
                                },
                                {
                                    key: 'canUnlinkCorp',
                                    value: this.dataoverview.data.sellsyadmin.canUnlinkCorp,
                                    type: 'bool',
                                },
                                {
                                    key: 'canChurnCustomer',
                                    value: this.dataoverview.data.sellsyadmin.canChurnCustomer,
                                    type: 'bool',
                                },
                                {
                                    key: 'thirdPayerId',
                                    value: this.dataoverview.data.sellsyadmin.thirdPayer.id,
                                },
                                {
                                    key: 'thirdPayerName',
                                    value: this.dataoverview.data.sellsyadmin.thirdPayer.name,
                                },
                                {
                                    key: 'displayTrialBanner',
                                    value: this.dataoverview.data.sellsyadmin.displayTrialBanner,
                                    type: 'bool',
                                },
                                {
                                    key: 'thirdId',
                                    value: this.dataoverview.data.sellsyadmin.thirdId,
                                },
                                {
                                    key: 'maintenance',
                                    value: this.dataoverview.data.sellsyadmin.maintenance,
                                    type: 'bool',
                                },
                            ];
                            for (const info of Object.keys(moreNavItem.data)) {
                                moreNavItem.data[info] = moreNavItem.data[info]
                                    ? buildUrl(moreNavItem.data[info], parameters)
                                    : '';
                            }
                        }
                        samMoreNav.push(moreNavItem);
                    }
                });
                return samMoreNav;
            }
        },
    },
};
